import { render, staticRenderFns } from "./GroundRent.vue?vue&type=template&id=d7b33634"
import script from "./GroundRent.vue?vue&type=script&lang=js"
export * from "./GroundRent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports